type ApiError = {
    response?: Response;
};

type ValidationErrorBody = {
    errors?: Array<{ value?: string; type?: unknown }>;
};

export type ValidationMessage = {
    key: string;
    state: { [property: string]: unknown };
};

function responseOf(error: unknown): Response | null {
    if (error == null || typeof error !== 'object') {
        return null;
    }

    const response = (error as ApiError).response;
    return response != null && typeof response.clone === 'function' ? response : null;
}

function stateOf(type: unknown): { [property: string]: unknown } {
    return type !== null && typeof type === 'object'
        ? (type as { [property: string]: unknown })
        : {};
}

export async function readValidationMessages(error: unknown): Promise<ValidationMessage[]> {
    const response = responseOf(error);

    if (response === null) {
        return [];
    }

    try {
        const body: ValidationErrorBody = await response.clone().json();
        return (body.errors || [])
            .filter((validationError) => typeof validationError.value === 'string' && validationError.value !== '')
            .map((validationError) => ({
                key: validationError.value as string,
                state: stateOf(validationError.type)
            }));
    } catch (parseError) {
        return [];
    }
}
